import { Component, OnInit } from '@angular/core';
import {Recurring} from "../../../../model/cart/Recurring";
import {Subscription} from "../../../../model/Subscription";
import {Router} from "@angular/router";
import {StartupService} from "../../../service-ui/startup.service";
import {NavbarService} from "../../../service-ui/navbar.service";
import {SubscriptionService} from "../../../service-data/subscription.service";
import {LoggedInCallback} from "../../../service-auth/cognito.service";
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit, LoggedInCallback {
  constructor(public router: Router, public startupService: StartupService, private navbarService: NavbarService, public subscriptionService: SubscriptionService) {
  }

  ngOnInit() {
    this.startupService.isAuthenticated(this);
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (!isLoggedIn) {
      console.log("Not logged in in Account");
      // this.router.navigate(['/home/login']);
    } else {
    }
  }

}
